// IMPORTANT NOTE: this component can be used either in BS3 or BS5 pages
import React from 'react';
import './terms_and_conditions.scss';

const TermsAndConditions: React.FC = () => {
  return (
    <div className='react-c-terms-and-conditions text-gray-li'>
      By continuing, you agree to the Devex{' '}
      <a href='/terms-and-conditions' target='_blank'>
        User Agreement
      </a>{' '}
      and{' '}
      <a href='/privacy-statement' target='_blank'>
        Privacy Statement
      </a>
      .
    </div>
  );
};

export default TermsAndConditions;
